import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ErrorTracking } from './error-tracking.service';

@Component({
  standalone: false,
  selector: 'fl-error-tracking',
  template: ` <ng-container></ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorTrackingComponent implements OnInit {
  private errorTracking = inject(ErrorTracking);

  ngOnInit(): void {
    this.errorTracking.setupSentrySDK();
  }
}
